<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['寄样管理', '寄样管理详情']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form ref="form" class="add-form" :model="form" label-width="240px">
              <el-form-item label="名称：">
                <el-input v-model="form.fullName" disabled></el-input>
              </el-form-item>
              <el-form-item label="所属公司：">
                <el-input v-model="form.companyName" disabled></el-input>
              </el-form-item>
              <el-form-item label="公司类别：">
                <el-input v-model="form.companyType" disabled></el-input>
              </el-form-item>
              <el-form-item label="职务：">
                <el-input v-model="form.position" disabled></el-input>
              </el-form-item>
              <el-form-item label="姓名：">
                <el-input v-model="form.contacts" disabled></el-input>
              </el-form-item>
              <el-form-item label="手机号：">
                <el-input v-model="form.phone" disabled></el-input>
              </el-form-item>
              <el-form-item label="地址：">
                <el-input v-model="form.address" disabled></el-input>
              </el-form-item>
              <el-form-item label="产品名：">
                <el-input v-model="form.productName" disabled></el-input>
              </el-form-item>
              <el-form-item label="品牌名：">
                <el-input v-model="form.brandName" disabled></el-input>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input v-model="form.detail" disabled type="textarea" :rows="5"></el-input>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button @click="back">返回</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'

export default {
  name: 'detail',
  data () {
    return {
      loading: false,
      form: {}
    }
  },
  components: {
    navHeader
  },
  methods: {
    getDetail (id) {
      this.$http
        .post('/applySendSample/detail', {id})
        .then((res) => {
          if (res.data.code === '200') {
            this.form = res.data.data
            this.form.companyType = this.form.one + '/' + this.form.two
          } else {
            this.$message.error(res.data.msg)
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    back () {
      this.$router.back()
    }
  },
  created () {
    if (this.$route.query.id) {
      this.loading = true
      this.getDetail(this.$route.query.id)
    } else {
      this.loading = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/SendingSamples/detail.vue